import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr-BE';
import localeNl from '@angular/common/locales/nl-BE';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';
import { AnalyticsEventProcessor } from './core/analytics/analytics-event.processor';
import { CoreModule } from './core/core.module';
import { EvSimulatorModule } from './modules/ev-simulator/ev-simulator.module';
import { EvcQuoteModule } from './modules/evc-quote/evc-quote.module';
import { EvcSegmentModule } from './modules/evc-segment/evc-segment.module';
import { EvcSmallBizModule } from './modules/evc-small-biz/evc-small-biz.module';
import { ModalNavigatorModule } from './modules/evc-small-biz/libs/component-lib/components/modal/navigator/modal.module';
import { AnalyticsModule } from './shared/modules/analytics/analytics.module';
import { register } from 'swiper/element/bundle';
register();
registerLocaleData(localeFr);
registerLocaleData(localeNl);
const httpLoaderFactory = (http: HttpClient) => new TranslateHttpLoader(http, AppSettings.pathToAssets);

@NgModule({
  declarations: [AppComponent],
  imports: [
    AngularSvgIconModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AnalyticsModule.forRoot(environment.googleTagManager, new AnalyticsEventProcessor()),
    EvSimulatorModule,
    EvcQuoteModule,
    EvcSegmentModule,
    NgbModule,
    ModalNavigatorModule,
    EvcSmallBizModule,
  ],
  providers: [CookieService, { provide: LOCALE_ID, useValue: 'fr-BE' }, NgbActiveModal],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
